import authAxios from '../authorization/axios';
import constants from '../constants';

class AlgorandAccountService {

  async getAccount(accountId: string) {
    try {
      const res = await authAxios.get(constants.api?.getAlgoAccount.replace('{accountId}', accountId));
      return res?.data.account;
    } catch (err) {
      console.log('Get account error', err);
      throw err;
    }
  }

  async getTransaction(accountId: string) {
    try {
      const res = await authAxios.get(`${constants.api?.getTransactionAccount.replace('{accountId}', accountId)}?limit=1`);
      return res?.data.transactions[0];
    } catch (err) {
      console.log('Get transaction error', err);
      throw err;
    }
  }

}

export default AlgorandAccountService;
